<section class="event-articles" id="events">

  <h3><span>Turniere und Events</span> bei uns im DRC Überblick</h3>

  <div class="slider">
    <swiper-container
      init="false"
      class="mySwiper"
    >
      <swiper-slide *ngFor="let post of posts">
        <div class="slide">
          <a [routerLink]="['/magazin', post.slug]" [attr.href]="'/magazin/' + post.slug">
            <div class="image">
              <img
                [ngSrc]="post.yoast_head_json.og_image[0].url"
                [width]="post.yoast_head_json.og_image[0].width"
                [height]="post.yoast_head_json.og_image[0].height"
                [alt]="post.yoast_head_json.og_title"
                itemprop="image">
            </div>
            <div class="description">
              <h4 itemprop="headline" [innerHTML]="post.title.rendered"></h4>
              <a class="button" [routerLink]="['/magazin', post.slug]" [attr.href]="'/magazin/' + post.slug">
                Artikel lesen
              </a>
            </div>
          </a>
        </div>
      </swiper-slide>
    </swiper-container>
  </div>
</section>
